import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import MainLayout from "./components/MainLayout";
import Enquiries from "./pages/Enquiries";
import Brandlist from "./pages/Brandlist";
import Productlist from "./pages/Productlist"; 
import Addbrand from "./pages/Addbrand";
import Addproduct from "./pages/Addproduct";
import ViewEnq from "./pages/ViewEnq";
import { PrivateRoutes } from "./routing/PrivateRoutes";
import { OpenRoutes } from "./routing/OpenRoutes";
import AddSize from "./pages/Addsize";
import SizeList from "./pages/SizeList";
import AddBrandModel from "./pages/AddBrandModel";
import BrandModellist from "./pages/brandModelList";
import AddFeature from "./pages/AddFeature";
import FeatureList from "./pages/FeaturesList";
import Bookings from "./pages/Boookings";
import ViewBooking from "./pages/ViewBooking";
import { useEffect, useState } from "react";
import AddClient from "./pages/AddClient";
import ClientList from "./pages/Clientlist";
import Subscribers from "./pages/Subscriber";
import Bloglist from "./pages/Bloglist";
import Addblog from "./pages/Addblog";

function App() {

  const [loading, setLoading] = useState(true);

  useEffect(() => {
     const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);  

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>

            {loading ? (
         <div className="loading-overlay">
         <div className="spinner"></div>
       </div>
           ) : (
      <>
 
      <Routes>
        <Route path="/" element={<OpenRoutes><Login /></OpenRoutes>} />
        <Route path="/admin" element={<PrivateRoutes><MainLayout /></PrivateRoutes>}>
          <Route index element={<Productlist />} />
          <Route path="enquiries" element={<Enquiries />} />
          <Route path="enquiries/:id" element={<ViewEnq />} />

          <Route path="bookings" element={<Bookings />} />
          <Route path="bookings/:id" element={<ViewBooking />} />

           <Route path="brand" element={<Addbrand />} />
          <Route path="brand/:id" element={<Addbrand />} />

          <Route path="brandModel" element={<AddBrandModel />} />
          <Route path="brandModel/:id" element={<AddBrandModel />} />

          <Route path="feature" element={<AddFeature />} />
          <Route path="feature/:id" element={<AddFeature />} />

          <Route path="features-list" element={<FeatureList />} />

          <Route path="engine-size" element={<AddSize />} />
          <Route path="engine-size/:id" element={<AddSize />} />
          <Route path="engine-size-list" element={<SizeList />} />
 

           <Route path="list-brand" element={<Brandlist />} />
          <Route path="list-brand-model" element={<BrandModellist />} />
         <Route path="client" element={<AddClient />} />
           <Route path="client/:slug" element={<AddClient />} />
    
         <Route path="client-list" element={<ClientList />} />


          <Route path="list-vehicle" element={<Productlist />} />
          <Route path="vehicle" element={<Addproduct />} />
          <Route path="vehicle/:slug" element={<Addproduct />} />
          <Route path="subscribers" element={<Subscribers />} />
         <Route path="blog-list" element={<Bloglist />} />
          <Route path="blog" element={<Addblog />} />
   
           <Route path="blog/:slug" element={<Addblog />} />
         

        </Route>
      </Routes>
      </>)}
    </Router>
  );
}

export default App;
